import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { TextToolTip } from '../toolTip';
import { Images } from 'utils';

export const EditableTableInputRow = ({ text, content, handleBlur }) => {
  const [isEdited, setIsEdited] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (text) {
      setInputValue(text);
    }
  }, [text]);

  useEffect(() => {
    if (isEdited) {
      setInputValue(text);
      inputRef.current.focus();
    }
  }, [isEdited]);


  const onBlur = () => {
    setIsEdited(false);
    if (handleBlur) {
      handleBlur(inputValue);
    }
  };

  return (
    <div
      className='editable-table-input-row-wrapper'
    >
      {!isEdited ?
        <div className='editable-table-input-row-content'>
          <TextToolTip text={text} content={content} />

          <button
            className='editable-table-input-row-edit-btn'
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsEdited(true);
            }}
          >
            <img src={Images.edit} alt='edit' />
          </button>
        </div>
        :
        <TextField
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          classes='editable-table-input-block'
          inputRef={inputRef}
          onBlur={(e) => onBlur(e)}
          onChange={(e) => setInputValue(e?.target?.value)}
          value={inputValue}
          variant='filled'
        />
      }
    </div>
  );
};

